import { TextInput } from '@mantine/core'
import React, { ChangeEvent } from 'react'

import { DefaultValueFilterProps } from '../../hooks/useDebouncedFilterValue/use-debounced-filter-value'
import useDebouncedFilterValue from '../../hooks/useDebouncedFilterValue/useDebouncedFilterValues'

const DefaultTextFilter = ({
  filterDefinition,
  sortFilter,
  ...textInputProps
}: DefaultValueFilterProps): React.ReactElement => {
  const { label } = filterDefinition

  const { value, onChange } = useDebouncedFilterValue<string>({
    sortFilter,
    filterDefinition,
  })

  return (
    <TextInput
      label={label}
      value={value}
      onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
      {...textInputProps}
    />
  )
}

export default DefaultTextFilter
